export default __webpack_public_path__ + "static/media/fire_rune.57cc5bed.svg";